<template>
  <div class="bind-card-page">
    <!-- Header with background image and navbar -->
    <div class="bind-header" style="background-image: url('/img/mine/login-bg.png'), linear-gradient(90deg, rgb(79, 43, 138), rgb(245, 96, 205));">
      <van-nav-bar :title="$t('setting.fill_bank') || '添加銀行卡'" class="bind-nav">
        <template #left>
          <van-icon name="arrow-left" color="#fff" @click="back()"/>
        </template>
      </van-nav-bar>
    </div>

    <!-- Body card floating over header -->
    <div class="bind-body">
      <div class="card form-card">
        <p class="form-tip">請輸入您的支付卡信息</p>

        <div class="form-item">
          <label>*姓名</label>
          <van-field
            v-model="username"
            :placeholder="$t('setting.username_place') || '請輸入姓名'"
            class="van-cell--borderless"
          />
        </div>

        <div class="form-item">
          <label>*銀行名稱</label>
          <van-field
            v-model="bank"
            :placeholder="$t('setting.band_name_tip') || '銀行名稱'"
            class="van-cell--borderless"
          />
        </div>

        <div class="form-item">
          <label>*分行名稱</label>
          <van-field
            v-model="bankfenhang"
            :placeholder="$t('setting.branch_name_tip') || '分行名稱'"
            class="van-cell--borderless"
          />
        </div>

        <div class="form-item">
          <label>*銀行帳號</label>
          <van-field
            v-model="bankid"
            :placeholder="$t('setting.band_account_tip') || '銀行帳號'"
            class="van-cell--borderless"
          />
        </div>

        <p class="form-warn">{{ $t('setting.bank_warn') || '親愛的用戶，為了確保您的資金安全，請鏈接您的真實姓名並設置取款密碼。如果您的姓名與帳戶名稱不匹配，您將無法提取資金。' }}</p>

        <button type="button" class="submit-btn" @click="bindCard()"> {{ $t('setting.bank_ok') || '確定綁卡' }} </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: "",
      bank: "",
      bankfenhang: "",
      bankid: ""
    };
  },
  methods: {
    back() {
      this.$router.push({ path: '/Mine' });
    },
    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info"
      }).then(res => {
        if (res && res.code === 200 && res.data) {
          this.username = res.data.name || res.data.username || "";
          this.bank = res.data.bank_name || res.data.bank || "";
          this.bankfenhang = res.data.bank_fen || res.data.bankfenhang || "";
          this.bankid = res.data.bank_card || res.data.bankid || "";
        }
      });
    },
    bindCard() {
      if (!this.username) {
        this.$toast(this.$t("setting.username_place") || "請輸入姓名");
        return;
      }
      if (!this.bank) {
        this.$toast(this.$t("setting.band_name_tip") || "請輸入銀行名稱");
        return;
      }
      if (!this.bankfenhang) {
        this.$toast(this.$t("setting.branch_name_tip") || "請輸入分行名稱");
        return;
      }
      if (!this.bankid) {
        this.$toast(this.$t("setting.band_account_tip") || "請輸入銀行帳號");
        return;
      }
      this.$http({
        method: "post",
        data: {
          username: this.username,
          bank: this.bank,
          bankfenhang: this.bankfenhang,
          bankid: this.bankid
        },
        url: "user_set_bank"
      }).then(res => {
        if (res && res.code === 200) {
          this.$toast.success(res.msg || "綁定成功");
          setTimeout(() => {
            return window.history.back();
          }, 800);
        } else {
          this.$toast(res ? res.msg : "失敗");
        }
      });
    }
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getUserInfo();
    }
  }
};
</script>

<style scoped>
.bind-card-page {
  width: 100%;
  min-height: 100vh;
  background-color: #f3f3f5;
  padding-bottom: 60px;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Helvetica Neue", STHeiti, "Microsoft Yahei", Tahoma, Simsun, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.bind-header {
  position: relative;
  width: 100%;
  height: 220px;
  background-image: url('/img/mine/login-bg.png'), linear-gradient(90deg, rgb(79, 43, 138), rgb(245, 96, 205));
  background-size: 100% auto;
  background-position: center bottom;
  background-repeat: no-repeat;
  box-sizing: border-box;
}

.bind-nav {
  background: transparent !important;
  height: 100px;
}

::v-deep .bind-nav .van-nav-bar__content {
  height: 100px;
}

::v-deep .bind-nav .van-nav-bar__title {
  color: #ffffff !important;
  font-size: 34px !important;
  font-weight: 600 !important;
  line-height: 100px;
}

::v-deep .bind-nav .van-icon {
  color: #ffffff !important;
  font-size: 44px !important;
}

.bind-body {
  padding: 0 30px;
  margin-top: -60px;
  position: relative;
  z-index: 10;
}

.form-card {
  background: #ffffff;
  border-radius: 24px;
  padding: 40px 30px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);
}

.form-tip {
  font-size: 28px;
  color: #888888;
  margin: 0 0 30px 0;
}

.form-item {
  margin-bottom: 24px;
}

.form-item label {
  display: block;
  font-size: 28px;
  color: #333333;
  margin-bottom: 12px;
  font-weight: 500;
}

.form-item .van-cell {
  background: #f7f7f9;
  border-radius: 16px;
  padding: 20px 24px;
}

::v-deep .form-item .van-field__control {
  font-size: 28px;
  color: #333333;
}

.form-warn {
  font-size: 24px;
  color: #ff4d4f;
  line-height: 1.5;
  margin: 30px 0 40px 0;
}

.submit-btn {
  display: block;
  width: 100%;
  height: 90px;
  margin-top: 40px;
  border: none;
  border-radius: 45px;
  background: linear-gradient(90deg, #f560cd, #4f2b8a);
  color: #ffffff;
  font-size: 32px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 6px 20px rgba(245, 96, 205, 0.3);
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.submit-btn:active {
  opacity: 0.85;
  transform: scale(0.99);
}
</style>
